import { render, staticRenderFns } from "./ClassCreate.vue?vue&type=template&id=04f88663"
import script from "../../controllers/class/class-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/class/class-create.js?vue&type=script&lang=js&external"
import style0 from "./ClassCreate.vue?vue&type=style&index=0&id=04f88663&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports